import { motion } from "framer-motion";
import React from "react";


export const AnimatedList = ({children, style}:{ children:any, style?:any }) => {
  const items = React.Children.toArray(children);
  return (
  <>
    {items.map((children:any, index:any) => (
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.4 + index * 0.1,
          type: "spring",
          stiffness: 120,
          damping: 12
        }}
        style={{ 
          willChange: 'transform, opacity',
          transform: 'none'
        }}
      >
        {children}
      </motion.div>
    ))}
  </>
  )
};
